import React from 'react';

import { ContentSection as ContentSectionComponent } from './Columns/ContentSection';
import { ContentBlocksProvider } from './ContentBlocksContext';
import {
  ColumnLayout,
  Content,
  ContentItemType,
  ContentSection,
  SectionProperties,
  Widget,
  getColumnById,
  getRoot,
  getSectionById,
  getWidgetById,
} from '@ael/core-api';

import './content-block-renderer.scss';
import { FroalaEditorsSettings } from 'src/config/configs';

export type FlatContentSection = {
  columnLayout: ColumnLayout;
  columns: FlatContentColumn[];
  properties: SectionProperties;
};

export type FlatContentColumn = {
  widget: Widget | undefined;
};

type FlattenedContent = {
  sections: FlatContentSection[];
};

const flattenContent = (content: Content): FlattenedContent => {
  const root = getRoot(content);
  const sections = root.value.sections
    .map((sectionId) => getSectionById(content)(sectionId))
    .filter((section) => !!section);
  return {
    sections: sections.map((section: ContentSection): FlatContentSection => {
      const columns = section.value.columns.map((columnId) => getColumnById(content)(columnId));
      return {
        columnLayout: section.value.columnLayout as ColumnLayout,
        columns: columns.map((column) => {
          if (!column.value.widget) {
            return { widget: undefined };
          }
          return { widget: getWidgetById(content)(column.value.widget) };
        }),
        properties: section.value.properties,
      };
    }),
  };
};

interface ContentRendererProps {
  inSmallWindow: boolean;
  contentItem: ContentItemType;
  content: Content;
  froalaEditorsSettings: FroalaEditorsSettings;
}

export const ContentBlocksRenderer = (props: ContentRendererProps) => {
  const flattenedContent = flattenContent(props.content);
  return (
    <ContentBlocksProvider contentItem={props.contentItem} key={props.contentItem.id} inSmallWindow={props.inSmallWindow}>
      <div className="content-renderer">
        {flattenedContent.sections.map((section, index) => (
          <ContentSectionComponent key={index} content={section} contentItemId={props.contentItem.id} froalaEditorsSettings={props.froalaEditorsSettings} />
        ))}
      </div>
    </ContentBlocksProvider>
  );
};
